<template>
    <div>

    <b-modal 
        no-close-on-backdrop 
        ref="itemModal" 
        id="itemModal" 
        :title="action + ' Configuration (' + version +')'" 
        :header-bg-variant="bgForVersion"
        hide-footer size="xl"
        @hide="cancel"
        >

        <div v-if="isBusy">
        <b-spinner class="align-middle"></b-spinner>
        <strong> Loading...</strong>
        </div>
        <div v-else>
            <b-card class="text-center" border-variant="light"  align="left" >
                <b-form>
                    <b-form-row>
                        <b-col>
                            <b-form-group
                                id="linetag"
                                label="Linetag"
                                label-for="linetag"
                                label-cols="3"
                                label-size="sm"
                                label-align="right"
                            >
                                <b-form-input
                                    id="linetag"
                                    type="text"
                                    required
                                    placeholder="Enter Linetag"
                                    autocomplete="off"
                                    size="sm"
                                    v-model="form.linetag"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                id="e_service_id"
                                label="Echo Service ID"
                                label-for="echo_service_id"
                                label-cols="3"
                                label-size="sm"
                                label-align="right"
                            >
                                <!--b-form-input
                                    id="echo_service_id"
                                    type="text"
                                    required
                                    placeholder="Enter Echo Service ID"
                                    autocomplete="off"
                                    size="sm"
                                    v-model="form.echo_service_id"
                                ></b-form-input-->

                                <AutoCompleteSelect :selectedValue="form.echo_service_id" field="Asset_Name" @selected="onCmdbSIDSelected"/>
                            </b-form-group>
                        </b-col>

                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="type"
                            label="Type"
                            label-for="type"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                        <b-form-select required v-model="form.type" :options="typeOptions" size="sm" ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="cpe_vendor"
                            label="CPE Vendor"
                            label-for="cpe_vendor"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                        <b-form-select required v-model="form.cpe_vendor" :options="cpeVendorOptions" size="sm" ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="supplier"
                            label="Supplier"
                            label-for="supplier"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >

                            <AutoCompleteSelect :selectedValue="form.supplier" @selected="onSupplierSelected" field="Supplier_Name_CSV"/>

                            <!--b-form-input
                                id="supplier"
                                type="text"
                                required
                                placeholder="Enter Supplier"
                                autocomplete="off"
                                size="sm"
                                v-model="form.supplier"
                            ></b-form-input-->
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="v_circuit_Id"
                            label="Vendor Circuit ID"
                            label-for="vendor_circuit_id"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-input
                                id="vendor_circuit_id"
                                type="text"
                                required
                                placeholder="Enter Vendor Circuit ID"
                                autocomplete="off"
                                size="sm"
                                v-model="form.vendor_circuit_id"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="core_router_name"
                            label="Core Router Name"
                            label-for="core_router_name"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <AutoCompleteSelect :selectedValue="form.core_router_name" field="Core_Router_Name" @selected="onCoreRouterNameSelected"/>

                            <!--b-form-input
                                id="core_router_name"
                                type="text"
                                required
                                placeholder="Enter Core Router Name"
                                autocomplete="off"
                                size="sm"
                                v-model="form.core_router_name"
                            ></b-form-input-->
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="core_router_interface"
                            label="Core Router Interface"
                            label-for="core_router_interface"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-input
                                id="core_router_interface"
                                type="text"
                                required
                                placeholder="Enter Core Router Interface"
                                autocomplete="off"
                                size="sm"
                                v-model="form.core_router_interface"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
            </b-form-row>

                <b-form-row right>
                    <b-col>
                        <b-form-group
                            id="wan_ip_range"
                            label="WAN IP Range"
                            label-for="wan_ip_range"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-input
                                id="wan_ip_range"
                                type="text"
                                required
                                placeholder="Enter WAN IP Range"
                                autocomplete="off"
                                size="sm"
                                v-model="form.wan_ip_range"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="remote_router_ip"
                            label="Remote Router IP"
                            label-for="remote_router_ip"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-input
                                id="remote_router_ip"
                                type="text"
                                required
                                placeholder="Enter Remote Router IP"
                                autocomplete="off"
                                size="sm"
                                v-model="form.remote_router_ip"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="remote_router_owner"
                            label="Remote Router Owner"
                            label-for="remote_router_owner"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-select required v-model="form.remote_router_owner" :options="remoteRouterOwnerOptions" size="sm" ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="remote_router_management"
                            label="Remote Router Management"
                            label-for="remote_router_management"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-select required v-model="form.remote_router_management" :options="remoteRouterManagementOptions" size="sm" ></b-form-select>
                        </b-form-group>
                    </b-col>

                </b-form-row>

                <b-form-row>
                    <b-col align="left">
                        <b-form-group
                            id="snmp"
                            label="SNMP"
                            label-for="snmp"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >                   
                            <b-form-group>
                                <b-form-row>
                                    <b-col>
                                        <b-form-radio v-model="form.selected_snmp" name="snmp_option" value="non_std" size="sm">Non-Standard</b-form-radio>
                                        <b-form-radio v-model="form.selected_snmp" name="snmp_option" value="std" size="sm">Standard</b-form-radio>
                                    </b-col>
                                    <b-col align="left" cols="8">    
                                        <b-form-input v-if="form.selected_snmp!=='std'"
                                            id="snmp"
                                            type="text"
                                            required
                                            placeholder="Enter SNMP String"
                                            autocomplete="off"
                                            size="sm"
                                            v-model="form.snmp"
                                        ></b-form-input>
                                    </b-col>
                                </b-form-row>
                            </b-form-group>
                        </b-form-group>
                    </b-col>
                    <b-col align="left">
                        <b-form-group
                            id="access_details"
                            label="Access Details"
                            label-for="access_details"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-group>
                                <b-form-row>
                                    <b-col>
                                        <b-form-radio v-model="form.selected_access" name="access_option" value="non_std" size="sm">Non-Standard</b-form-radio>
                                        <b-form-radio v-model="form.selected_access" name="access_option" value="std" size="sm">Standard</b-form-radio>
                                    </b-col>
                                    <b-col align="left" cols="8">   
                                        <b-form-group
                                            v-if="form.selected_access!=='std'"
                                            id="access_user"
                                            label="User"
                                            label-for="access_user"
                                            label-cols="4"
                                            label-size="sm"
                                            label-align="right"
                                        >
                                            <b-form-input 
                                                id="access_user"
                                                type="text"
                                                required
                                                placeholder="Username"
                                                autocomplete="off"
                                                size="sm"
                                                v-model="form.access_user"
                                            ></b-form-input>

                                        </b-form-group>
                                        <b-form-group 
                                            v-if="form.selected_access!=='std'"
                                            id="access_pswd"
                                            label="Password"
                                            label-for="access_pswd"
                                            label-cols="4"
                                            label-size="sm"
                                            label-align="right"
                                        >
                                            <b-form-input 
                                                id="access_pswd"
                                                type="password"
                                                required
                                                placeholder="Enter Password"
                                                autocomplete="off"
                                                size="sm"
                                                v-model="form.access_pswd"
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-form-row>
                            </b-form-group>
                        </b-form-group>
                    </b-col>
                </b-form-row>


                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="notes"
                            label="Notes"
                            label-for="notes"
                            label-cols="1"
                            label-size="sm"
                            label-align="right"
                        >
                            <b-form-textarea
                                id="notes"
                                required
                                placeholder="Enter Notes"
                                autocomplete="off"
                                size="sm"
                                rows="3"
                                max-rows="6"
                                v-model="form.notes"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-form-row>


                <!--b-form-row>
                    <b-col>
                        <CmdbSIDSelect :selectedSID="form.echo_service_id" @selected="onCmdbSIDSelected"/>
                    </b-col>
                </b-form-row-->



                <b-form-row>
                    <b-col>
                        <b-form-group
                            v-if="updatedAt!==''"
                            id="last_updated"
                            label="Last Updated"
                            label-for="last_updated"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                            disabled
                        >
                            <b-form-input
                                id="last_updated"
                                type="text"
                                size="sm"
                                v-model="getLastUpdated"
                                disabled
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            v-if="updatedBy!==''"
                            id="last_updated_by"
                            label="Last Updated By"
                            label-for="last_updated_by"
                            label-cols="3"
                            label-size="sm"
                            label-align="right"
                            disabled
                        >
                            <b-form-input
                                id="last_updated_by"
                                type="text"
                                size="sm"
                                :value="updatedBy"
                                disabled
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                </b-form-row>


                <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:32px; font-size:15px; valign:center">
                    <div style="line-height:5px">{{lastError}}</div>                        
                </b-alert>

                <b-alert v-if="validation_errors.length" show variant="danger" align="center" class="m-2" style="font-size:15px; valign:center">
                    <div >
                        <b>Please correct the following error(s) or <i>Save As Draft</i> and come back later:</b>
                        <div v-for="error in validation_errors">{{ error }}</div>
                    </div>                        
                </b-alert>



                <b-alert v-if="action =='Delete'" show variant="warning" align="center" class="m-2" style="height:32px; font-size:15px; valign:center">
                    <div style="line-height:5px">This action is irreversible!</div>                        
                </b-alert>


                <b-row v-if="action=='View'" align-h="end">
                    <b-col style="text-align:center">
                        <b-button v-if="modifyAccess" v-on:click='getConfigHistory()' variant="success" size="sm" class="mr-1">View Configuration History</b-button>
                    </b-col>
                    <b-col style="text-align:right">
                        
                        <b-button v-on:click='cancel' variant="info" size="sm" class="mr-1">Cancel</b-button>
                        <b-button v-if="modifyAccess" :variant="saveDraftVariant" v-on:click="confirmSave('edit', 'Draft')" size="sm" class="mr-1">{{saveDraftBtnText}}</b-button>
                        <b-button v-if="modifyAccess" :variant="saveVariant" v-on:click="confirmSave('edit')" size="sm" class="mr-1">{{saveBtnText}}</b-button>
                        <b-button v-if="modifyAccess" v-on:click="confirmDelete" :variant="deleteVariant" size="sm" class="mr-1">{{deleteBtnText}}</b-button>                   
                    </b-col>    
                </b-row>


                <b-row v-else align-h="end">
                    <b-col style="text-align:right">
                        <b-button v-on:click='cancel' variant="info" size="sm" class="mr-1">Cancel</b-button>
                        <b-button v-on:click="confirmSave('create','Draft')" :variant="saveDraftVariant" size="sm" class="mr-1">{{saveDraftBtnText}}</b-button>
                        <b-button v-on:click="confirmSave('create')" :variant="saveVariant" size="sm">{{saveBtnText}}</b-button>
                    </b-col>    
                </b-row>

                </b-form>

            </b-card>
        </div>
    </b-modal>

    <b-modal 
        ref="historyModal" 
        id="historyModal" 
        title="Item History (recent to oldest)" 
        ok-variant="info"
        cancel-variant="info"
        scrollable
        size="lg"
        button-size="sm"
        >
        <div style="word-break: break-all;word-wrap: break-word;overflow-wrap: break-word;">
            <ol>
                <li v-for="item in historyItems">
                    {{ JSON.stringify(item) }} 
                </li>
            </ol>
        </div>
    </b-modal>

    </div>

</template>

<script>
import CMDBService from '@/api-services/cmdb.service'
import AutoCompleteSelect from '@/components/cmdb/AutoCompleteSelect.vue'

import { mapGetters } from 'vuex'
import { Auth } from 'aws-amplify'

const moment = require('moment')
const isIp = require('is-ip')
const isCidr = require('is-cidr')

export default {
    name: 'CMDBConfig',
    components: {
        AutoCompleteSelect
    },
    data() {
        return {
            typeOptions: [
                { value: 'Unspecified', text: 'Select type..' },
                { value: 'MPLS', text: 'MPLS' },
                { value: 'WWW-DIA', text: 'WWW-DIA' },
                { value: 'VPLS', text: 'VPLS'}
            ],
            remoteRouterOwnerOptions: [
                { value: 'Unspecified', text: 'Select Remote Router Owner..' },
                { value: 'Echo', text: 'Echo' },
                { value: 'Client', text: 'Client' },
                { value: 'Echo Partner', text: 'Echo Partner'}
            ],
            remoteRouterManagementOptions: [
                { value: 'Unspecified', text: 'Select Remote Router Management..' },
                { value: 'Echo', text: 'Echo' },
                { value: 'Client', text: 'Client' },
                { value: 'Echo Partner', text: 'Echo Partner'}
            ],
            cpeVendorOptions: [
                { value: 'Unspecified', text: 'Select CPE Vendor..' },
                { value: 'Billion', text: 'Billion' },
                { value: 'Cisco', text: 'Cisco' },
                { value: 'Fortinet', text: 'Fortinet' },
                { value: 'HUAWEI', text: 'HUAWEI'},
                { value: 'Mikrotik', text: 'Mikrotik'},
            ],
            lastError: '',
            form: {
                linetag: '',
                echo_service_id: '',
                type: 'Unspecified',
                cpe_vendor: 'Unspecified',
                supplier: '',
                vendor_circuit_id: '',
                core_router_name: '',
                core_router_interface: '',
                wan_ip_range: '',
                remote_router_ip: '',
                remote_router_owner: 'Unspecified',
                remote_router_management: 'Unspecified',
                snmp:'',
                access_user:'',
                access_pswd:'',
                selected_snmp: 'std',
                selected_access: 'std',
                notes: '',
            },
            linetagOnLoad:'',
            updatedAt : '',
            updatedBy : '',
            version : 'Draft/Complete',
            historyItems: [],
            validation_errors:[],
            action:'Add New',
            saveBtnText:'Save As Complete',
            saveVariant:'info',
            deleteBtnText:'Delete Config',
            deleteVariant:'info',
            saveDraftBtnText:'Save As Draft',
            saveDraftVariant:'info',
            config:null,
            isBusy:false,
        }
    },
    props: {
        guid: String,
    },
    mounted(){
        // this.viewCanEnter()  
        if (this.guid!==null){
            this.action='View'
            this.$refs.itemModal.show()
            this.getConfig()
        } else {
            this.action='Add New'
            this.$refs.itemModal.show()
        }
    },
    computed:{
        ...mapGetters('authstore', {
            userApplications: 'userApplications',
            userName: 'userName',
        }),
        modifyAccess(){
            if (this.userApplications['/cmdb'].includes("Cmdb (Full Access)")){
                return true
            }
        },
        getLastUpdated(){
            if (this.updatedAt===''){
                return("Not applicable")
            } else {
                return moment(this.updatedAt).format("LLLL")    
            }
        },
        bgForVersion(){
            if (this.version=="Draft"){
                return("warning")
            } else {
                return("light")
            }
        },
    },
    methods: {
        //https://stackoverflow.com/questions/48733000/aws-amplify-how-to-check-if-user-is-logged-in
        // async viewCanEnter(){ 
        //     try  { 
        //         await Auth.currentAuthenticatedUser() 
        //         return true 
        //     } 
        //     catch(e) { 
        //         alert("user is not logged in")
        //         return false 
        //     }
        // },

        // async ionViewCanEnter(){
        //     return await Auth.currentAuthenticatedUser()
        //     .then(() => { return true; })
        //     .catch(() => { return false; });
        // }
        onCmdbSIDSelected (value){
            this.form.echo_service_id = value
        },
        onCoreRouterNameSelected(value){
            this.form.core_router_name = value
        },
        onSupplierSelected(value){
           this.form.supplier = value
        },
        getConfig() {
            this.isBusy=true
            let promise = CMDBService.getConfig(this.guid)
            return promise.then((data) => {
                this.config=data.Item
                this.form.linetag = (this.config.linetag==null) ? '' : this.config.linetag.trim() //if null set to '' else set to trim(val)
                this.form.echo_service_id= (this.config.echo_service_id==null) ? '' : this.config.echo_service_id.trim()
                this.form.type = this.config.type || 'Unspecified'
                this.form.cpe_vendor = this.config.cpe_vendor || 'Unspecified'
                this.form.supplier = (this.config.supplier==null) ? '' : this.config.supplier.trim()
                this.form.vendor_circuit_id=(this.config.vendor_circuit_id==undefined) ? '' : this.config.vendor_circuit_id.trim()
                this.form.core_router_name=(this.config.core_router_name==null) ? '' : this.config.core_router_name.trim()
                this.form.core_router_interface = (this.config.core_router_interface==null) ? '' : this.config.core_router_interface.trim()
                this.form.wan_ip_range = (this.config.wan_ip_range==null) ? '' : this.config.wan_ip_range.trim()
                this.form.remote_router_ip = (this.config.remote_router_ip==null) ? '' : this.config.remote_router_ip.trim()
                this.form.remote_router_owner = (this.config.remote_router_owner==null) ? '' : this.config.remote_router_owner.trim() || 'Unspecified'
                this.form.remote_router_management = this.config.remote_router_management || 'Unspecified'
                this.form.selected_snmp = this.config.selected_snmp || 'std'
                this.form.snmp = (this.config.snmp==null) ? '' : this.config.snmp.trim()
                this.form.selected_access = (this.config.selected_access==null) ? '' : this.config.selected_access.trim() || 'std'
                this.form.access_user = (this.config.access_user==null) ? '' : this.config.access_user.trim()
                this.form.access_pswd = (this.config.access_pswd==null) ? '' : this.config.access_pswd.trim()
                this.form.notes = (this.config.notes==null) ? '' : this.config.notes.trim()
                this.updatedAt = this.config.updatedAt
                this.updatedBy = this.config.updatedBy
                this.version = this.config.version
                this.linetagOnLoad=(this.config.linetag==null) ? '' : this.config.linetag.trim()
                this.isBusy=false
           }).catch(error => {
               console.log("hello")
                console.log(error.config)        
                console.log(JSON.stringify(error.response))        
                console.log(JSON.stringify(error.message))        
                // console.log(JSON.stringify(error.response.data.error))
                // console.log(JSON.stringify(error.response.data))

                if (error.response){
                    console.log(error.response.data.error)
                } else if (error.message){
                console.log(error.message)
                } else {
                    console.log(JSON.stringify(error))        
                }
                this.isBusy=false
            })               
        },
        checkForm: function (e){
            
            if (this.form.linetag==='') {
                this.validation_errors.push('Linetag required.')
            }           
            if (!["name1","name2"].includes(this.form.core_router_name)) {
                console.log(this.form.core_router_name)
                this.validation_errors.push('Invalid core router name specified. Allowed values are \'name1\' or \'name2\'')
            }
           
            if (!isIp(this.form.remote_router_ip)) {
                console.log(this.form.remote_router_ip)
                this.validation_errors.push('Invalid remote router IP specified. Please use a valid IPv4 or IPv6 address')
            }

            if (![4,6].includes(isCidr(this.form.wan_ip_range))) {
                console.log(this.form.wan_ip_range)
                this.validation_errors.push('Invalid WAN IP range specified. Please specify a valid range using IPv4 or IPv6 CIDR notation')
            }

            if (this.form.type=='Unspecified') {
                this.validation_errors.push('Type required.')
            }           

            if (this.validation_errors.length>0){
                return false
            } else{
                return true
            }
        }, 
        async confirmSave(action, version='Complete') {
            if (version=='Complete'){
                if (this.saveBtnText == "Confirm Save As Complete?"){
                    let success = await this.save(action, version)
                    this.saveBtnText="Save As Complete"
                    this.saveVariant="info"
                } else {
                    this.deleteBtnText="Delete Config"
                    this.deleteVariant="info"
                    this.saveBtnText = "Confirm Save As Complete?"
                    this.saveVariant="warning"
                    this.saveDraftBtnText="Save As Draft"
                    this.saveDraftVariant="info"
                }
            } else { //user saving a draft
                if (this.saveDraftBtnText == "Confirm Save As Draft?"){
                    let success = await this.save(action, version)
                    this.saveDraftBtnText="Save As Draft"
                    this.saveDraftVariant="info"
                } else {
                    this.deleteBtnText="Delete Config"
                    this.deleteVariant="info"
                    this.saveDraftBtnText = "Confirm Save As Draft?"
                    this.saveDraftVariant="warning"
                    this.saveBtnText="Save As Complete"
                    this.saveVariant="info"
                }
            }
        },
        async confirmDelete() {
            if (this.deleteBtnText == "Confirm Deletion?"){
                await this.deleteConfig()
                this.deleteBtnText="Delete Config"
                this.deleteVariant="info"
            } else {
                this.saveBtnText="Save As Complete"
                this.saveVariant="info"
                this.saveDraftBtnText="Save As Draft"
                this.saveDraftVariant="info"
                this.deleteBtnText = "Confirm Deletion?"
                this.deleteVariant="warning"
            }
        },
        save(action, version='Complete') {

            this.lastError=''
            this.validation_errors = []

            if (version=='Complete'){ //only validate for Complete version
                if (this.checkForm() === false){
                    return false
                }
            }

            this.form.version = version
            this.form.updatedBy = this.userName

            if (this.form.selected_snmp == 'std'){
                this.form.snmp = ''
            }

            if (this.form.selected_access == 'std'){
                this.form.access_user = ''
                this.form.access_pswd = ''
            }

            console.log(this.form)

            //if this.network is set then this is an edit
            if (action=="edit"){
                let promise = CMDBService.updateConfig(this.config.guid, this.linetagOnLoad, this.form)
                return promise.then((data) => {
                    this.$emit('updated')
                }).catch(error => {
                    console.log(error.response.data.error)
                    this.lastError=error.response.data.error
                })        
            } else if (action=="create") { //is an add  new network
                let promise = CMDBService.createConfig(this.form)
                return promise.then((data) => {
                    this.$emit('updated')
                }).catch(error => {
                    console.log(error)
                    if (error.response) {
                        console.log(error.response)
                        if (error.response.data.error!==null){
                            this.lastError=error.response.data.error
                        }
                        /*
                        * The request was made and the server responded with a
                        * status code that falls out of the range of 2xx
                        */
                        console.log("response")
                        console.log(error.response);
//                         console.log("message")
//                         console.log(error.message);
// //                        console.log(error.response.data.message);
//                         console.log("response data.message")
//                         console.log(error.response.data);
                        // this.lastError=error.response.data.hint
                        // console.log(error.response.data.hint)
                        // console.log("resp status")
                        // console.log(error.response.status);
                        // console.log("resp headers")

                        // console.log(error.response.headers);
                        
                    } else if (error.request) {
                        /*
                        * The request was made but no response was received, `error.request`
                        * is an instance of XMLHttpRequest in the browser and an instance
                        * of http.ClientRequest in Node.js
                        */
                        console.log("request error")
                        console.log(error.request);
                        this.lastError=error.request 
                    } else {
                        // Something happened in setting up the request and triggered an Error
                        console.log("other error")
                        console.log('Error', error.message);
                        this.lastError=error.message
                    }
                    console.log(error.config);
//                    this.lastError=error.config

                })        
            } 
        },
        deleteConfig() {
            let promise = CMDBService.deleteConfig(this.config.guid, this.config.linetag)
            return promise.then((data) => {
                console.log(data)
                this.$emit('updated')
            }).catch(error => {
                console.log(error.response)
                this.lastError=error.response.data.error
            })        
        },
        getConfigHistory() {
            let promise = CMDBService.getConfigHistory(this.config.guid)
            return promise.then((data) => {
                this.historyItems=data.Items
                this.$refs.historyModal.show()
            }).catch(error => {
                this.historyItems=[error.response.data.error]
                // console.log(error.response)
                // this.lastError=error.response.data.error
                //alert(error.response.data.error)
                this.$refs.historyModal.show()
            })        
        },
        cancel() {
            this.$emit('cancelled')
        },
    }
}
</script>
